<script setup lang="ts">
import MemberPartsCombination from '@/components/memberManagement/MemberPartsCombination.vue'
</script>

<template>
  <div class="member-management">
    <MemberPartsCombination></MemberPartsCombination>
  </div>
</template>

<style lang="scss" scoped>
.member-management {
  margin: 0.5%;
}
</style>
